import { createSlice } from '@reduxjs/toolkit';
import { setToken,getToken, removeToken } from '../../utils/token';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    token: getToken() || null,
    user: null,
  },
  reducers: {
    setCredentials: (state, action) => {
      state.token = action.payload.token;
      state.user = action.payload.user;
      setToken(action.payload.token);
    },
    logout: (state) => {
      state.token = null;
      state.user = null;
      removeToken();
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;
